/** 
* @param str string
* Takes long string and separate word by space bewtween
*/
export function fixString(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).replace(/[A-Z]/g, ' $&').trim()
}